import * as eff from 'redux-saga/effects';
import createActionCreators from 'redux-resource-action-creators';

import {
  actionTypes,
} from '../actions';
import {
  throwError,
} from './helpers';

import api from '../api';

export default function* clientNotesFlow() {
  function* fetchNotes({
    clientId,
    callbacks,
  }: any): Generator<eff.Effect, void, any> {
    const actions = createActionCreators('read', {
      resourceType: 'clientNotes',
      requestKey: 'fetchClientNotes',
    })

    try {
      const response = yield eff.call(
        api.fetchClientNotes,
        {
          qs: {
            client_id: clientId,
          },
        },
      )

      yield eff.put(
        actions.succeeded({
          resources: response,
          list: String(clientId),
        })
      )

      callbacks?.setSubmitting?.(false)
      callbacks?.onSuccess?.(response)
    } catch (e) {
      yield eff.put(
        actions.failed({
          resources: [],
        })
      )
      callbacks?.setSubmitting?.(false)
      callbacks?.onError?.(e)
      yield eff.call(throwError, e)
    }
  }

  function* createNote({
    clientId,
    description,
    callbacks,
  }: any): Generator<eff.Effect, void, any> {
    const actions = createActionCreators('create', {
      resourceType: 'clientNotes',
      requestKey: 'createClientNotes',
    })

    try {
      const response = yield eff.call(
        api.createClientNotes,
        {
          body: {
            client_id: clientId,
            description: description,
          },
        },
      )

      yield eff.put(
        actions.succeeded({
          resources: [response],
          list: String(clientId),
        })
      )

      callbacks?.setSubmitting?.(false)
      callbacks?.onSuccess?.(response)
    } catch (e) {
      yield eff.put(
        actions.failed({
          resources: [],
        })
      )
      callbacks?.setSubmitting?.(false)
      callbacks?.onError?.(e)
      yield eff.call(throwError, e)
    }
  }

  function* updateNote({
    id,
    description,
    callbacks,
  }: any): Generator<eff.Effect, void, any> {
    const actions = createActionCreators('update', {
      resourceType: 'clientNotes',
      resources: [id],
      requestKey: 'updateClientNotes',
    })

    try {
      const response = yield eff.call(
        api.updateClientNotes,
        {
          id,
          body: {
            description: description,
          },
        },
      )

      yield eff.put(
        actions.succeeded({
          resources: [response],
        })
      )

      callbacks?.setSubmitting?.(false)
      callbacks?.onSuccess?.(response)
    } catch (e) {
      yield eff.put(
        actions.failed({
          resources: [],
        })
      )
      callbacks?.setSubmitting?.(false)
      callbacks?.onError?.(e)
      yield eff.call(throwError, e)
    }
  }

  function* deleteNote({
    id,
    callbacks,
  }: any): Generator<eff.Effect, void, any> {
    const actions = createActionCreators('delete', {
      resourceType: 'clientNotes',
      resources: [id],
      requestKey: 'deleteClientNotes',
    })

    try {
      yield eff.call(
        api.deleteClientNotes,
        {
          id,
        },
      )

      yield eff.put(
        actions.succeeded({
          resources: [id],
        })
      )

      callbacks?.setSubmitting?.(false)
      callbacks?.onSuccess?.(id)
    } catch (e) {
      yield eff.put(
        actions.failed({
          resources: [],
        })
      )
      callbacks?.setSubmitting?.(false)
      callbacks?.onError?.(e)
      yield eff.call(throwError, e)
    }
  }

  yield eff.takeEvery(actionTypes.REQUEST_FETCH_CLIENT_NOTES, fetchNotes);
  yield eff.takeEvery(actionTypes.REQUEST_CREATE_CLIENT_NOTES, createNote);
  yield eff.takeEvery(actionTypes.REQUEST_UPDATE_CLIENT_NOTES, updateNote);
  yield eff.takeEvery(actionTypes.REQUEST_DELETE_CLIENT_NOTES, deleteNote);
}
